module.exports = __webpack_public_path__ + "static/img/nsfc.fd5d51d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/nsfc.png
// module id = xB5y
// module chunks = 0